import { useCallback, useEffect } from 'react';
import {
  PRESCRIBER,
} from '../../constants/patientChart.constant';
import {
  NavBar, NavItem, NavKey,
} from '../../components/patientChart';
import { PageHeading, useAvatarTitle } from '../../components/PageHeading';
import useNavItems from '../../hooks/useNavItems';
import { FEATURE } from '../../utils/feature';
import Logo from '../../assets/logo.png';
import '../patientChart/styles.css';

const hasFeature = FEATURE();

const SelectedNavItem = {
  key: ''
};

export const NavItems = [
  /*
  NavItem.get(NavKey.sv),
  NavItem.get(NavKey.ao),
  NavItem.get(NavKey.tasks),
  NavItem.get(NavKey.reports),
  */
  NavItem.get(NavKey.pcm),
  /*
  NavItem.get(NavKey.so),
  */
];

export const PageNotFound = ({
  history,
  selectedPrescriberInfo: prescriber = PRESCRIBER(),
  scheduledVisits = {},
  asyncOrders = {},
  tasksInfo = {},

  GetHeaderInfo: getPrescriber = async () => {},
  LogOff: logOff = async () => ({}),
}) => {
  const { navItems } = useNavItems({
    scheduledVisits: scheduledVisits?.visits?.data || [],
    asyncOrders: asyncOrders?.visits?.data || [],
    tasks: tasksInfo?.data || [],
    items: NavItems,
    history,
  });

  const { avatarTitle } = useAvatarTitle(prescriber);

  useEffect(() => {
    if (!prescriber.FirstName) {
      getPrescriber();
    }
  }, []);

  const handleRoute = useCallback((url = '') => {
    history.push(url);
  }, [history]);

  const PageHeadingComponent = new Map([
    [true, (
      <PageHeading
        logo={Logo}
        message={prescriber.Message}
        avatarTitle={avatarTitle}
        hasActions
        logOff={logOff}
        handler={{
          route: handleRoute,
        }}
      />
    )],
    [false, <></>]
  ]);

  const NavBarComponent = new Map([
    [true, <NavBar items={navItems} selectedItem={SelectedNavItem} />],
    [false, <></>]
  ]);

  return (
    <div className='patient-chart-container flex flex-column flex-fill'>
      {PageHeadingComponent.get(hasFeature.PAGE_HEADING)}

      <div className='patient-chart-content flex gap-24'>
        {NavBarComponent.get(hasFeature.NAV_BAR)}

        <div className='patient-chart-info-cards flex flex-column flex-fill align-items-center justify-content-center font-18 tracking-wider'>
          PAGE NOT FOUND!!
        </div>

        <div className='flex'></div>
      </div>
    </div>
  );
};

export default PageNotFound;
